/**
 * SONDAGE MEMBRES (public) — /sondage-membres : consultation de décembre avant le bilan de janvier.
 */
import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const ROLES = [["parent", "Parent"], ["eleve", "Élève"], ["membre", "Membre adulte"], ["coach", "Coach / instructeur"]];

export default function SondageMembresPublic() {
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("parent");
  const [state, setState] = useState(null);
  useEffect(() => { axios.get(`${API}/api/public/rentree/survey`).then((r) => setQuestions(r.data.questions)).catch(() => {}); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { await axios.post(`${API}/api/public/rentree/survey`, { email, role, answers }); setState("ok"); }
    catch (err) { setState(err.response?.data?.detail || "Erreur — réessaie."); }
  };
  if (state === "ok") return <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-8 text-center" data-testid="survey-thanks"><div><div className="text-5xl mb-4">🥋</div><h1 className="text-3xl font-black">Merci !</h1><p className="text-zinc-400 mt-2">Vos réponses aideront à préparer le bilan de janvier-février. Un degré chaque jour.</p></div></div>;
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 px-5 py-10 max-w-2xl mx-auto" data-testid="survey-page">
      <div className="text-amber-400 text-xs tracking-[0.35em] uppercase font-bold">Institut Impact Élite Martial · Consultation des membres</div>
      <h1 className="text-4xl sm:text-5xl font-black mt-1 leading-tight">Votre avis compte</h1>
      <p className="text-zinc-400 mt-2">3 minutes · 6 questions · réponses confidentielles, pour préparer le bilan de janvier-février.</p>
      <form onSubmit={submit} className="mt-8 space-y-5">
        <div className="flex flex-wrap gap-2" data-testid="survey-roles">{ROLES.map(([v, l]) => <button type="button" key={v} onClick={() => setRole(v)} data-testid={`survey-role-${v}`} className={`px-3 py-1.5 rounded-full text-xs border ${role === v ? "bg-amber-500 text-zinc-950 border-amber-500 font-bold" : "border-zinc-700 text-zinc-400"}`}>{l}</button>)}</div>
        {questions.map((q, i) => (
          <label key={q.id} className="block">
            <span className="text-sm font-semibold text-zinc-100"><span className="text-amber-400 mr-2">{i + 1}.</span>{q.q}</span>
            <textarea rows={3} value={answers[q.id] || ""} onChange={(e) => setAnswers({ ...answers, [q.id]: e.target.value })} className="mt-1.5 w-full rounded-xl border border-zinc-800 bg-zinc-900/60 px-3 py-2 text-sm text-zinc-100 focus:border-amber-500 outline-none" data-testid={`survey-q-${q.id}`} />
          </label>
        ))}
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Courriel (facultatif)" className="w-full rounded-xl border border-zinc-800 bg-zinc-900/60 px-3 py-2 text-sm" data-testid="survey-email" />
        {state && state !== "ok" && <div className="text-red-400 text-sm" data-testid="survey-error">{state}</div>}
        <button type="submit" className="px-5 py-2.5 rounded-lg bg-amber-500 text-zinc-950 font-bold" data-testid="survey-submit">Envoyer mes réponses</button>
      </form>
    </div>
  );
}
